module.exports = __webpack_public_path__ + "static/media/pic_backuser.f87d6085.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_backuser.png
// module id = 358
// module chunks = 0